export default "__VITE_ASSET__B5x3Jlx5__"